"use client";

import React from "react";
import Link from "next/link";

const ReadyForBrighterSmile: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Ready for a Brighter Smile in Astoria?
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          At Smile4Me, patients receive a level of care no drugstore kit can
          offer. Dr. Khaimov evaluates your teeth before treatment, calibrates
          the whitening formula to your specific needs, and monitors results from
          start to finish.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          That combination of clinical oversight, custom application, and
          professional-strength formulas is what sets our approach apart. You
          leave with a personalized aftercare plan and a clear path to lasting
          results.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Getting started is simple:
        </p>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <strong>
              Call or{" "}
              <Link
                href="https://app.nexhealth.com/appt/smile4me_dental_care?lid=77847&tracking_key=b2d71902-5ce0-43c1-bc95-24cdee27de9a"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
                aria-label="Book online at Smile4Me Dental Care"
              >
                book online
              </Link>
            </strong>{" "}
            &mdash; Schedule your whitening consultation
          </li>
          <li>
            <strong>Come in for your shade assessment</strong> &mdash;
            We&apos;ll evaluate your teeth and discuss your goals
          </li>
          <li>
            <strong>Start treatment</strong> &mdash; In-office whitening is
            available the same day for qualified patients
          </li>
          <li>
            <strong>Enjoy your results</strong> &mdash; Leave with a
            personalized aftercare plan and touch-up options
          </li>
        </ul>
      </div>
    </section>
  );
};

export default ReadyForBrighterSmile;
